module.exports = __webpack_public_path__ + "img/ksteel_logo.6337dee5.png";